import { createApp } from "vue";
import "./reset.css"; // 初始化样式
import "/node_modules/flag-icons/css/flag-icons.min.css"; // 引入各国国旗
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { i18n } from "./language";
import { Buffer } from "buffer";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import vThrottleClick from "./utils/throttleClick";
import { NoticeBar } from "vant";

window.Buffer = Buffer;

let app = createApp(App);
app.directive("throttle-click", vThrottleClick); // 注册全局指令

app.use(VueSweetalert2).use(createPinia()).use(router).use(i18n).use(NoticeBar);

app.mount("#app");
